/*
 * @Author: 任晓帅
 * @Contact: VX:ren18321147631
 * @Date: 2026-02-15 08:35:23
 * @Description: 不可进行二次销售
 */
import request from '@/utils/request'

/**
 * 用户认证相关接口
 */
export default {
  /**
   * 用户登录
   * @param {Object} data - 登录信息
   */
  login(data) {
    return request({
      url: '/shop/login',
      method: 'post',
      data
    })
  },
  /*
    * 密码登录
  */
  loginByPwd(data) {
    return request({
      url: '/shop/login/pwd',
      method: 'post',
      data
    })
  },
  /**
   * 用户注册
   * @param {Object} data - 注册信息
   */
  register(data) {
    return request({
      url: '/shop/login/register',
      method: 'post',
      data
    })
  },
  /**
   * 用户登出
   */
  logout() {
    return request({
      url: '/auth/logout',
      method: 'post'
    })
  },

  /**
   * 获取用户信息
   */
  getInfo() {
    return request({
      url: '/shop/account',
      method: 'get'
    })
  },
  /**
   * 发送验证码
   * @param {string} phone - 手机号
   */
  sendVerificationCode(phone) {
    return request({
      url: '/shop/login/sms',
      method: 'post',
      data: { 'phone': phone }
    })
  },

  /**
   * 修改密码
   * @param {Object} data - 修改密码信息
   */
  changePassword(data) {
    return request({
      url: '/shop/account/pwd',
      method: 'post',
      data
    })
  },
  /**
   * 修改账号信息
   * @param {Object} data - 账号信息
   * header string  必需
    *name string 
   */
  changeAccount(data) {
    return request({
      url: '/shop/account',
      method: 'post',
      data
    })
  }

}